<template>
    <div class="container-fluid">
        <b-table-header :value="tableOptions" header-slot-class="b-header-slot w-100" @optionChange="handleOptionChange">
            <queue-pause-button :show-pause-resume-button="props.showPauseResumeButton" container-class="position-relative top-50"></queue-pause-button>
            <slot name="header.toolbar"></slot>
        </b-table-header>
        <b-table :items="queueItems"
                 :columns="columns"
                 caption="Task list"
                 :value="tableOptions"
                 class="mt-1">
            <template v-slot:cell.fileName="{item, column}">
                <span v-html="item.fileName"></span>
            </template>
            <template v-slot:cell.status="{item, column}">
                <span v-html="item.status"></span>
            </template>
        </b-table>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, watch, PropType } from 'vue';
import { useQueueStore } from '@/stores/queueStore';
import BTable from "./BTable/BTable.vue";
import BTableHeader from "./BTable/BTableHeader.vue";
import { BTableColumn, BTableOptions } from './BTable/BTable.types';
import { AxiosResponse } from 'axios';
import QueuePauseButton from './QueuePauseButton.vue';
import { QueueItem } from '@/types';
import { BFilter, BFilterableField } from './BFilterEditor/BFilterEditor.types';

const props = defineProps<{
    showPauseResumeButton: boolean
}>()
const queueStore = useQueueStore();

//table settings and column info
var tableOptions= ref({
                        totalItemCount: 0,
                        itemsPerPage: 25,
                        page: 1,
                        sortBy: [{
                            key: 'start',
                            isDescending: true
                        }]
                    } as BTableOptions);

const columns = computed(() => {

    let data: BTableColumn[] = [];

    data.push({ key: 'status', text: 'Status', sortable: false, value: (item) => item.status },
        { key: 'type', text: 'Type', sortable: false, value: (item) => item.type },
        { key: 'start', text: 'Start', sortable: false, value: (item) => item.start },
        { key: 'end', text: 'End', sortable: false, value: (item) => item.end });

    return data;
});
 
var queueItems = ref([] as QueueItem[]);
function getQueueItems(){
    queueStore.getQueueItems(tableOptions.value.page, tableOptions.value.itemsPerPage, [] as BFilter[], [] as BFilterableField[], tableOptions.value.sortBy).then((response) => {
        tableOptions.value.totalItemCount = response.data.total;
        if(Array.isArray(response.data.data)){
            queueItems.value = response.data.data;
        }
    });
}

function handleOptionChange() {
    getQueueItems();
}

getQueueItems();

</script>